import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import React, { ChangeEvent, useCallback } from "react";

export interface TableFilterCheckboxProps extends Omit<CheckboxProps, "onChange" | "value"> {
  value: boolean;
  onChange?: (newValue: boolean) => void;
}

export const TableFilterCheckbox: React.FC<TableFilterCheckboxProps> = ({
  value,
  onChange = () => null /* Default is to do nothing */,
  children,
  ...rest
}) => {
  const onEventChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
    [onChange]
  );

  const defaultStyle: CheckboxProps = {
    borderWidth: "base",
    borderRadius: "base",
    marginBottom: 4,
    marginTop: 4,
    marginRight: 4,
    padding: 3,
  };

  return (
    <Checkbox isChecked={value} onChange={onEventChange} {...{ ...defaultStyle, ...rest }}>
      {children}
    </Checkbox>
  );
};
